import React from 'react';
import Dialog from 'pages/Dashboard/components/Dialog';
import WriteOffForm from 'pages/Dashboard/pages/Billing/WriteOffForm';
import {
  useMedia,
  useNotify,
} from 'core/hooks';
import {
  VisitNoteDTO,
} from 'dtos/visitNoteDTO';
import {
  PatientCompact,
} from 'pages/Dashboard/pages/Encounters/types/patient';
import {
  useGetWriteOffs,
} from 'pages/Dashboard/pages/Billing/hooks';
import Skeleton from '@mui/material/Skeleton';
import Name from 'pages/Dashboard/components/Name';

export type WriteOffDialogProps = {
  patient?: PatientCompact;
} & Pick<VisitNoteDTO,
  'encounterId'
  | 'visitDateTime'
>;

type Props = WriteOffDialogProps & {
  onClose: () => void;
};

function Title({
  patient = {},
}: Props) {
  const { getMediaPathById } = useMedia();
  const src = getMediaPathById(patient?.patientId ?? 0) ?? '';
  return (
    <div className="flex flex-col pb-2">
      <h3 className="text-base font-semibold flex flex-col gap-px">
        <span>Add Write Off</span>
        <small className="text-gray-500">
          <Name
            image={{ src, size: 'xs' }}
            {...patient?.formattedNames}
          />
        </small>
      </h3>
    </div>
  );
}

export default function WriteOffDialog({
  encounterId,
  visitDateTime,
  onClose,
  patient,
}: Props) {
  const notify = useNotify();

  const {
    data = [],
    isLoading,
  } = useGetWriteOffs(encounterId ?? 0);

  const onUpdate = () => {
    notify({
      message: 'Write Off applied successfully',
      variant: 'success',
    });
    onClose?.();
  };

  return (
    <Dialog
      open
      onClose={onClose}
      title={(
        <Title
          patient={patient}
          onClose={onClose}
          visitDateTime={visitDateTime}
        />
      )}
      className="w-[30rem] flex justify-start min-h-[220px]"
    >
      {isLoading ? (
        <div className="flex flex-col gap-2">
          <Skeleton variant="rectangular" height={30} />
          <Skeleton variant="rectangular" height={30} />
        </div>
      ) : (
        <WriteOffForm
          onUpdate={onUpdate}
          onCancel={onClose}
          value={data.length > 0 ? data : [{ encounterId }]}
          classes={{
            add: '!w-full !max-w-[unset] !border !border-dotted !border-blue-500',
          }}
        />
      )}
    </Dialog>
  );
}
